export const CONSTANT = {
  IMAGE_TIP: {
    LOADING: '/static/images/loading.gif',
    ERROR: '/static/images/error.png'
  },
  ANSWER_BY_KEYWORD: [
    // {
    //   keyword: ['你好', '您好'],
    //   answer: '您可输入关键字自行查询，致电<a class="blue" href="tel:96510">96510</a>进行咨询服务，或选择<b class="blue">人工客服</b>进行咨询'
    // },
    {
      keyword: ['有用'],
      answer: 'face[抱抱] 谢谢鼓励我们会再接再厉的哦。'
    }
  ],
  ANSWER_NO_REPLY: '抱歉，请输入关键字（例如停水）进行问题查询，或选择<b class="blue" type="connect">人工客服</b>进行咨询。',
  USELESS_TIP: '问题已发送人工客服，请稍等',
  HISTORY_DIVIDING: '----- 以上为历史消息 -----',
  CONNECT_TIP: '连接中...',
  CONNECT_DESC: '亲爱的用户，正在为您安排合适的客服',
  NOT_TIME_NIGHT_TIP: '抱歉，人工客服工作时间为8:00-21:00，若有问题，请您致电<a class="blue" href="tel:96510">96510</a>，敬请谅解。',
  NOT_TIME_TIP: '抱歉，客服繁忙，若有问题，请致电<a class="blue" href="tel:96510">96510</a>咨询。',
  CUSTOMER_BUSY_TIP: '抱歉，在线客服忙，请您耐心等待，或致电<a class="blue" href="tel:96510">96510</a>咨询。',
  CONNECTED_TIP: '客服{}为您服务',
  RECONNECT_TIP: '网络异常，是否<b class="blue" type="connect">重新连接</b>',
  RECONNECT_TIMEOUER_TIP: '已断开连接，<b class="blue" type="connect">重新连接</b>',
  RECONNECT_FIRST_TIP: '欢迎进入武水集团客服系统，我们将全程为您服务。',
  RECONNECT_SECOND_TIP: '您好，请问有什么可以帮助您？',
  NOT_REPLY_TIP: '抱歉，请稍等！',
  WITHDRAW_SUCCESS: '你已撤回一条消息',
  LOADING_TIP: '抱歉，您前面还有<b>{}</b>位用户在排队，请您耐心等待，您也可以拨打<a class="blue" href="tel:96510">96510</a>进行咨询',
}



// WEBPACK FOOTER //
// ./src/constant/index.js